<div class="h-full flex flex-col justify-between">
    <div class="detail panel-content">
        <div class="header">
            <app-title
                class="header-title font-medium text-2xl"
                [title]="'editLayer' | transloco"
                (goToPreviousPage)="goToPreviousPage.emit()" />
        </div>
        <div class="content h-full">
            <ng-content />
        </div>
    </div>

    <div class="footer justify-end">
        <app-button
            [disabled]="!isFormValid()"
            [icon]="['fas', 'check']"
            [label]="'submit' | transloco"
            [type]="ButtonType.PRIMARY"
            (onClick)="submit.emit()" />
    </div>
</div>
